$(function(){

  // button in the parts page - scrolling down to submit a request
  $('#shopify-section-template--17403481161974__media_with_text_yBVkqg .button').click(function() {
    $('html, body').animate({
        scrollTop: $('#shopify-section-template--17403481161974__custom_parts_form_gJM9iq').offset().top
    }, 300);
  });

  
});